import React, {useState} from "react";
import {Columns, Heading, Modal, Section, Form, Button} from "react-bulma-components";
import ContactSection from "../../Contact/ContactSection";
import DepartmentSelector from "../../Settings/Departments/DepartmentSelector";
import axios from "axios";
import {NotificationManager} from "react-notifications";


export default function CreateQuoteModal({show, setShow, rental, endpoint, departments, departmentObjects}){
    const [quoteState, setQuoteState] = useState({
        customer: {},
        customer2: {},
        department: null
    });

    const onCreate = () => {
        let dataToSave = {...quoteState};
        if(rental){
            dataToSave.rental = rental;
            dataToSave.vehicle = rental.vehicle;
            const conf ={
                url: endpoint+"createquotefromrental",
                method: "post",
                data: dataToSave
            }
            axios(conf).then(res => {
                console.log(res.data)
                setShow(false);
                window.open(`/editquote/${res.data.id}`, "_self");
            }).catch(err=>{
                NotificationManager.error("There was an error creating quote");
            })
        } else{
            NotificationManager.error("Could not find rental. Please refresh page and try again");
        }
    }

    const handleUpdate = data => {
        let newState = {...quoteState, ...data};
        setQuoteState(newState);
    }

    const onChange = e => {
        let data = {[e.target.name]: e.target.value};
        handleUpdate(data);
    }

    const handleUpdateCustomer = (e, name) => {
        let newData = {[name]: e};
        handleUpdate(newData);
    }

    const onDepartmentChange = (e) => {
        const toUpdate = {
            target: {
                name: e.target.name,
                value: departmentObjects[e.target.value]
            }
        };
        onChange(toUpdate);
    }

    return (
        <Modal
            show={show}
            onClose={() => setShow(false)}
            closeOnBlur
        >
            <Modal.Content className={"wider-modal"}>
                <Section style={{background: "white"}}>
                    <Columns>
                        <Columns.Column>
                            <Heading>Create Quote</Heading>
                        </Columns.Column>
                    </Columns>
                    <Columns>
                        <Columns.Column>
                            <ContactSection
                                title="Customer 1"
                                contactUpdate={(e) => handleUpdateCustomer(e, "customer")}
                                endpoint={endpoint + "contacts"}
                                contact={quoteState.customer}
                                type="CC"
                                fullSearch
                            />
                        </Columns.Column>
                        <Columns.Column>
                            <ContactSection
                                title="Customer 2"
                                contactUpdate={(e) => handleUpdateCustomer(e, "customer2")}
                                endpoint={endpoint + "contacts"}
                                contact={quoteState.customer2}
                                type="CC"
                                fullSearch
                            />
                        </Columns.Column>
                    </Columns>
                    <Columns>
                        <Columns.Column>
                            <DepartmentSelector
                                options={departments}
                                name={"department"}
                                label={"Department"}
                                onChange={onDepartmentChange}
                                value={quoteState.department}
                                blank={true}
                            />
                        </Columns.Column>
                        <Columns.Column>
                            <Form.Label>Provision Start Date</Form.Label>
                            <Form.Input
                                type={"date"}
                                name={"provisional_start_date"}
                                onChange={onChange}
                            />
                        </Columns.Column>
                        <Columns.Column>
                            <Form.Label>Quote Description</Form.Label>
                            <Form.Input
                                type={"text"}
                                name={"description"}
                                onChange={onChange}
                            />
                        </Columns.Column>
                    </Columns>
                    <Columns>
                        <Columns.Column>
                            <Button
                                color={"info"}
                                fullwidth
                                onClick={() => setShow(false)}
                            >
                                Cancel
                            </Button>
                        </Columns.Column>
                        <Columns.Column>
                            <Button
                                color={"success"}
                                fullwidth
                                onClick={onCreate}
                            >
                                Create
                            </Button>
                        </Columns.Column>
                    </Columns>
                </Section>
            </Modal.Content>
        </Modal>
    )







}